import styled from 'styled-components';

export const StyledPage = styled.div`
  margin-top: 4rem;
  padding: 1rem;
  text-align: center;
`;
